<template>
  <div class="level">
    <div class="jiangli_top">
      <p class="">财富有料</p>
    </div>
    <div class="level_con">
      <div class="level_con_top">
        <img src="../../assets/images/licai/poster.png" alt="" />
      </div>
      <!-- 新问推送 -->
      <div class="home_msg">
        <img src="/h5/img/jrrd.cf2510ff.png" alt="" />
        <div class="home_msg_con">
          <swiper class="swiper-wrapper" :options="swiperOptions">
            <swiper-slide v-for="(item, index) in newsList" :key="index" class="home_msg_con_a overflow1">{{ item.title }}</swiper-slide>
          </swiper>
        </div>
      </div>
      <!-- 新闻列表 -->
      <div class="level_con_item">
        <list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="getArticleList"
        >
          <div
            class="level_con_news"
            v-for="(item, index) in newsList"
            :key="index"
            @click="tocon(item.id)"
          >
            <div class="level_con_news_left">
              <p class="">{{ item.title }}</p>
              <p class="">{{ item.browse }} 阅读</p>
            </div>
            <div class="level_con_news_right">
              <img :src="item.image" alt="" />
            </div>
          </div>
        </list>
      </div>
    </div>
  </div>
</template>
<script>
import { getblock, getArticleList } from "../../api/public";
import List from "vant/lib/list";
import "vant/lib/button/style";
import {
  swiper,
  swiperSlide
} from "vue-awesome-swiper";
export default {
  components: {
    List,
    swiper,
    swiperSlide
  },
  data: function() {
    return {
      hot: '/h5/img/poster.bdebebac.png',
      swiperOptions: {
        autoplay: true,
        slidesPerView : 2,
        direction: "vertical",
        loop: true
      },
      loading: false,
      finished: false,
      page: 1,
      TzItem: "",
      newsList: []
    };
  },
  methods: {
tocon(type){
   this.$router.push({
        path: "/NewsDetail/"+type
      });
},
getArticleList() {
      getArticleList({
        cid: "7",
        page: this.page
      }).then(res => {
        console.log(res.data)
        if (res.data.data.length > 0) {
          this.newsList = this.newsList.concat(res.data.data);
          this.page++
        } else {
          this.finished = true
        }
        this.loading = false
      });
    },
    // 初始化获取投资栏目
    getTzItem() {
      getblock({
        pid: 1
      }).then(res => {
        this.TzItem = res.data;
      });
    },
    // 进入商品列表
    details(uid, Tzname) {
      this.$router.push({
        path: "/goods_list?id=" + uid + "&title=" + Tzname
      });
    }
  }
};
</script>

<style scoped lang="scss">
.level_con_item {
  height: 54vh;
  overflow: scroll;
}
.van-list{
  ::v-deep .van-list__loading {
    color: #969799;
    font-size: 14px;
    line-height: 50px;
    text-align: center;
  }
  ::v-deep .van-list__finished-text {
    color: #969799;
    font-size: 14px;
    line-height: 50px;
    text-align: center;
  }
  ::v-deep .van-list__error-text {
    color: #969799;
    font-size: 14px;
    line-height: 50px;
    text-align: center;
  }
}
.level_con_news_left {
  width: 66%;
  padding: 15px 0;
}

.level_con_news_left p:first-child {
  font-size: 16px;
  font-family: Microsoft YaHei, serif;
  font-weight: 400;
  color: #333333;
  line-height: 20px;
}

.level_con_news_left p:last-child {
  font-size: 13px;
  font-family: Microsoft YaHei, serif;
  font-weight: 400;
  color: #999999;
  line-height: 36px;
}

.level_con_news {
  background-color: #ffffff;
  display: flex;
  align-items: center;
  padding: 6px 15px;
  margin-top: 10px;
}

.jiangli_top {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
}

.level_con {
  padding: 20px 15px;
}

.level_con_top {
  width: 100%;
  height: 143px;
}

.level_con_top img {
  width: 100%;
  height: 100%;
}

.home_msg_con {
  margin-left: 15px;
  width: 85%;
  font-size: 14px;
  line-height: 21px;
  height: 100%;
}

.home_msg img {
  width: 37px;
  height: 37px;
}

.level_con_news_right {
  width: 120px;
  height: 120px;
}

.level_con_news_right img {
  width: 100%;
  height: 100%;
}

.home_msg {
  background-color: #ffffff;
  margin-top: 10px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 14px 24px;
  height: 70px;
}
</style>
